const liveChatSkeletonStyle = {
    outerContainer: `flex flex-col gap-2`,
    chatContainer: `flex items-end gap-3 max-w-[90%]`,
    messageContainer: `w-full h-[50px] bg-themeOverlay rounded-[10px] animate-pulse`,
    imageContainer: `min-h-[150px] min-w-[150px] w-[40%] bg-themeOverlay rounded-[10px] animate-pulse`,

}

export { liveChatSkeletonStyle }